import { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useResponsiveHelper } from "@/contexts/responsiveContext";
import { DEMO_SCHEDULE_ROUTE } from "@/components/router";
import {
  SignupFrameMaxWidth,
  SignupFrameMaxHeight,
  ScheduleFrameMaxWidth,
  ScheduleFrameMaxHeight,
  ScheduleFrameMaxHeightMobile
} from "../constants/dialogFrame";

export function useDialogFrameDimensions() {
  const { isTabletOrMobile } = useResponsiveHelper();
  const location = useLocation();

  const [frameMaxWidth, setFrameMaxWidth] = useState(SignupFrameMaxWidth);
  const [frameMaxHeight, setFrameMaxHeight] = useState(SignupFrameMaxHeight);

  useEffect(() => {
    if (isTabletOrMobile) {
      setFrameMaxWidth(window.innerWidth);
      setFrameMaxHeight(window.innerHeight);
    } else if (location.pathname.indexOf(DEMO_SCHEDULE_ROUTE) > -1) {
      if (isTabletOrMobile) {
        setFrameMaxWidth(ScheduleFrameMaxWidth);
        setFrameMaxHeight(ScheduleFrameMaxHeightMobile);
      } else {
        setFrameMaxWidth(ScheduleFrameMaxWidth);
        setFrameMaxHeight(ScheduleFrameMaxHeight);
      }
    } else {
      setFrameMaxWidth(SignupFrameMaxWidth);
      setFrameMaxHeight(SignupFrameMaxHeight);
    }
  }, [location.pathname, isTabletOrMobile]);

  const dialogFrameHeight = useMemo(() => {
    if (isTabletOrMobile) {
      return window.innerHeight;
    }

    return window.innerHeight < ScheduleFrameMaxHeight ? window.innerHeight : ScheduleFrameMaxHeight;
  }, [location.pathname, isTabletOrMobile]);

  return { frameMaxWidth, frameMaxHeight, dialogFrameHeight };
}
